export default __webpack_public_path__ + "static/media/gcloud-zone.66c69d75.png";